import {useCallback} from 'react';
import {useModal} from 'extensions/viewport/useModal';
import {ModalFileDrop} from 'interface/stacks/ModalFileDrop';

export function useModalFileDrop(id: string, name: string, isActive: boolean, primaryColor: string) {
  const modal = useModal();
  const open = useCallback(() => {
    modal.open(
      <ModalFileDrop {...{id, name, isActive, primaryColor, exit: modal.exit}}/>
    );
  }, [id]);
  return {open, exit: modal.exit};
}
